<template>
  <component
    :is="link ? NuxtLink : 'div'"
    :to="localePath(link || '')"
    :target="target || '_self'"
    :class="[
      'transform-colors text-center text-base duration-100 md:text-[17px] xl:text-xl xl:leading-[120%] 2xl:text-[23px]/[29px]',
      {
        'hover:text-gray-medium underline underline-offset-2': link,
      },
    ]"
  >
    <h2>{{ title }}</h2>
  </component>
</template>

<script setup lang="ts">
import { NuxtLink } from '#components'

interface Props {
  title: string
  link?: string
  target?: string
}

const props = defineProps<Props>()
const localePath = useLocalePath()
</script>
